<template>
    <el-dialog
            class="gantt-chart-dialog"
            fullscreen
            :title="$t('project_gantChartModal_title')"
            :visible.sync="dialogVisible"
            v-if="dialogVisible"
            :before-close="handleClose">
      <div class="gantt-chart-dialog__header">
        <div class="top-row">
          <div class="group-name">
            {{$t('project_gantChartModalView')}}
          </div>
          <el-radio-group v-model="zoom" class="radio-priority" @change="changeZoom">
            <el-radio label="day">
              {{$t('project_gantChartModalDays')}}
            </el-radio>
            <el-radio label="week">
              {{$t('project_gantChartModalWeek')}}
            </el-radio>
            <el-radio label="month">
              {{$t('project_gantChartModalMonth')}}
            </el-radio>
            <el-radio label="quarter">
              {{$t('project_gantChartModalQuarter')}}
            </el-radio>
            <el-radio label="year">
              {{$t('project_gantChartModalYear')}}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="bottom-row">
          <div class="group-name">
            {{$t('project_gantChartModalPriority')}}
          </div>
          <el-radio-group v-model="priority" class="radio-priority" @change="changePrioriry">
            <el-radio label="All">
              {{$t('project_gantChartModalAll')}}
            </el-radio>
            <el-radio label="Low">
              {{$t('project_gantChartModalLow')}}
            </el-radio>
            <el-radio label="Normal">
              {{$t('project_gantChartModalNormal')}}
            </el-radio>
            <el-radio label="High">
              {{$t('project_gantChartModalHigh')}}
            </el-radio>
            <el-radio label="Urgent">
              {{$t('project_gantChartModalUrgent')}}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="duration-in-days-block">
        {{$t('project_gantChartModalDurationInDays')}}
      </div>
        <div class="container">
            <gantt class="left-container"
                   :key="key"
                   :tasks="tasks"
                   :rowData="rowData"
                   :projectPermission="projectPermission"
                   ref="ganttChart"
                   @setNewDates="setNewDates"></gantt>
        </div>
    </el-dialog>
</template>

<script>
  import axios from 'axios'
  import Gantt from './Gantt.vue';
  export default {
    name: "GantChartModal",
    components: {
      Gantt
    },
    props: {
      rowData: {
        type: Array,
        default: () => ([])
      },
      projectPermission: {
        type: Object,
        default: () => ({})
      }
    },
    data(){
      return{
        dialogVisible: false,
        tasks: {
          data: [
            // {id: 1, text: 'Task #1', start_date: '2020-01-17', duration: 3, progress: 0.6},
            // {id: 2, text: 'Task #2', start_date: '2020-01-20', duration: 3, progress: 0.4}
          ],
          links: null
        },
        priority: 'All',
        zoom: 'day',
        key: 1
      }
    },
    methods:{
      async openModal(){
        try {
          const tasksList = await this.getProjectGanttChartTasks();
          this.tasks.data = tasksList
          console.log('ganttChart', this.$refs.ganttChart)
          this.key = this.key + 1
          this.dialogVisible = true
        } catch (err){
          console.log(err)
        }
      },
      getProjectGanttChartTasks(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/projectTasks/listGantChart?projectId=${this.$route.query.projectId}`)
            .then(response => {
              console.log('hello2131231', response.data)
              loader.hide()
              response.data.newlist.forEach(val => {
                switch (val.status) {
                  case 'created':
                    val.color = '#909399';
                    break;
                  case 'done':
                    val.color = '#67c23a';
                    break;
                  case 'hold':
                    val.color = '#f56c6c';
                    break;
                  case 'inProgress':
                    val.color = '#e6a23c';
                    break;
                  case 'started':
                    val.color = '#e6a23c';
                    break;
                }
              })
              resolve(response.data.newlist)
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
        })
      },
      setNewDates(data){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/setNewDateGantChart?companyId=${this.$route.query.companyId}`, data)
          .then(async response => {
            console.log('hello2131231', response.data)
            this.notification(this.$t('general_success'), this.$t('project_editTask'), "success");
            this.refreshTree()
            const tasksList = await this.getProjectGanttChartTasks();
            this.tasks.data = tasksList
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      refreshTree() {
        if (this.$route.query.projectId && this.$route.query.taskId && this.$route.query.taskId.toString() !== '0') {
          this.$emit('refreshTree', Number(this.$route.query.projectId), false, Number(this.$route.query.taskId))
        } else {
          this.$emit('refreshTree', Number(this.$route.query.projectId))
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changePrioriry(val){
        this.$refs.ganttChart.changePriority(val);
      },
      changeZoom(val){
        this.$refs.ganttChart.doZooming(val);
      },
      handleClose(){
        this.$refs.ganttChart.closeGantt();
        this.dialogVisible = false
      }
    }
  }
</script>

<style lang="less" scoped>
    .gantt-chart-dialog{
        /deep/.el-dialog__body{
            height: calc(100% - 55px);
        }
        &__header{
            //display:flex;
            //height:30px;
            //align-items:center;
          position: absolute;
          left: 200px;
          top: 25px;
          .top-row {
            display: flex;
            align-items: center;
          }
          .bottom-row {
            display: flex;
            margin-top: 15px;
          }
            .group-name{
              font-weight:bold;
              width: 60px;
            }
        }
      .duration-in-days-block {
        position: absolute;
        top: 58px;
      }
    }
    .container {
        height: 100%;
        width: 100%;
        position: relative;
        .radio-priority{
            margin:0 10px;
            /*position: absolute;*/
            /*top: -20px;*/
        }
    }
    .left-container {
        overflow: hidden;
        position: relative;
        height: calc(100% - 74px);
    }
    /deep/.el-radio{
      margin-right:20px;
      width: 60px;
    }
</style>
